import { formatFilterTime, languageRenderHelper } from '../renderHelper';
import { DownloadConfigInfoType } from '../types';

export const AllReviewsSupportLanguage: DownloadConfigInfoType = {
  columns: ({ auxiliaryParams }) => {
    const tableColumns: any = [
      {
        key: 'language',
        header: 'Language',
        renderHelper: [languageRenderHelper],
      },
      {
        key: 'all_reviews',
        header: 'All Reviews',
      },
      {
        key: 'negative',
        header: 'All  Reviews Negative%',
        numFmt: ['0.00%'],
      },
      {
        key: 'positive',
        header: 'All  Reviews Positive%',
        numFmt: ['0.00%'],
      },
    ];

    return tableColumns;
  },
};

export const SingleSupportedLanguageReviews: DownloadConfigInfoType = {
  columns: ({ auxiliaryParams }) => {
    const { dateType } = auxiliaryParams;

    const renderTime = formatFilterTime({ date_type: dateType });

    const tableColumns: any = [
      {
        key: 'time',
        header: 'Date',
        fixed: 'left',
        renderHelper: [renderTime],
      },
      {
        key: 'all_reviews',
        header: 'All Reviews',
      },
      {
        key: 'positive',
        header: 'All  Reviews Positive%',
        numFmt: ['0%'],
      },
    ];

    return tableColumns;
  },
};
